var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessCards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 224.939,
    cy: 224.938,
    r: 7.484
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.939,
    cy: 256,
    r: 7.484
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.939,
    cy: 287.062,
    r: 7.484
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.939,
    cy: 318.124,
    r: 7.484
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.939,
    cy: 349.185,
    r: 7.484
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m46.595 317.608v31.578c0 4.143 3.358 7.5 7.5 7.5h124.249c4.142 0 7.5-3.357 7.5-7.5v-31.578c0-9.305-5.912-17.587-14.712-20.61l-29.063-9.985c8.415-7.268 13.757-18.003 13.757-29.969 0-21.839-17.767-39.605-39.606-39.605s-39.606 17.767-39.606 39.605c0 11.966 5.342 22.701 13.757 29.969l-29.063 9.985c-8.8 3.023-14.713 11.306-14.713 20.61zm69.625-85.17c13.568 0 24.606 11.038 24.606 24.605s-11.038 24.605-24.606 24.605-24.606-11.038-24.606-24.605 11.038-24.605 24.606-24.605zm-54.625 85.17c0-2.9 1.843-5.482 4.586-6.425l42.183-14.492h15.71l42.184 14.492c2.743.942 4.586 3.524 4.586 6.425v24.078h-109.249z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 263.5h139.78c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5h-139.78c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 232.438 139.78-.001c4.142 0 7.5-3.358 7.5-7.5 0-4.143-3.358-7.5-7.5-7.5l-139.78.001c-4.142 0-7.5 3.358-7.5 7.5 0 4.143 3.358 7.5 7.5 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 294.563h139.78c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5h-139.78c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 325.625h139.78c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5h-139.78c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.593 341.687h-46.593c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h46.593c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m504.5 93.19h-322.35c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h314.85v233.5h-16.06v-100.41c0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v131.47h-16.07v-209.94c0-4.143-3.358-7.5-7.5-7.5h-396.31v-16.06h419.88v69.34c0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-76.84c0-4.143-3.358-7.5-7.5-7.5h-396.31v-16.06h72.33c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5h-79.83c-4.142 0-7.5 3.357-7.5 7.5v23.56h-23.57c-4.142 0-7.5 3.357-7.5 7.5v23.56h-23.56c-4.142 0-7.5 3.357-7.5 7.5v248.5c0 4.143 3.358 7.5 7.5 7.5h278.75c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5h-271.25v-233.5h419.87v233.5h-115.93c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h123.43c4.142 0 7.5-3.357 7.5-7.5v-23.56h23.57c4.142 0 7.5-3.357 7.5-7.5v-23.56h23.56c4.142 0 7.5-3.357 7.5-7.5v-248.5c0-4.142-3.358-7.5-7.5-7.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessCards);
export default __webpack_public_path__ + "static/media/business-cards.204f2d1980af11a0b3beddc465b0b7c6.svg";
export { ForwardRef as ReactComponent };